import { saveWebCookie, webCookie } from "@/lib/cookies";

//  §TODO 09.04.2026/CW <GKS-6347@33064> Sobald alle Normen preheated wurden, kann das weg
$("[data-masseinheit]").on("click", function() {
	if (webCookie.values) {
		webCookie.values.Masseinheit = $(this).attr("data-masseinheit");
		saveWebCookie();
	}

	location.reload();

	return false;
});

$("input[name='unit-mass']").on("change", e => {
	const radioBox = e.currentTarget as HTMLInputElement;
	if (webCookie.values && radioBox.value !== undefined) {
		webCookie.values.Masseinheit = radioBox.value;
		saveWebCookie();
	}

	location.reload();
});
